import parameters from './parameters';
export * from './parameters';

export default { parameters };
